/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { IRecordPageOwnProps, IRecordPageStateProps, IRecordPageDispatchProps, RecordPage } from "../../components/record/RecordPage";
import { ITypedOption } from "../../models/common/typedOption";
import { getRecordPage, RecordThunkDispatch } from "source/models/store/record";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IRecordPageOwnProps): IRecordPageStateProps {
    if (!applicationState || !applicationState.front) {
        return {
            appState: null,
            dataId: -1,
            recordPage: null,
            list: null,
            report: null
        };
    }
    const record = applicationState.record;
    return {
        appState: applicationState.session,
        dataId: record.page.dataId,
        recordPage: record.page.recordPage,
        list: record.list,
        report: record.report,
    };
}

export function mapDispatchToProps(dispatch: RecordThunkDispatch): IRecordPageDispatchProps {
    return {
        onGetRecordsPage: () => dispatch(getRecordPage()),
        onLogout: () => dispatch(storeEffects.logout()),
        onSetCulture: (culture: string) => dispatch(storeEffects.setCulture(culture)),
        onSaveUserParameters: (parameters: ITypedOption[]) => dispatch(storeEffects.saveUserParameters(parameters)),
        onRefreshSessionState: () => dispatch(storeEffects.refreshSessionState()),
    };
}

export default connect<IRecordPageStateProps, IRecordPageDispatchProps, IRecordPageOwnProps>(mapStateToProps, mapDispatchToProps)(RecordPage);